import { DDate } from '@amarkets/atlas/esm/lib/d-date';

export const formatDate = (date: Date | string, format: string = 'DD.MM.YYYY') => new DDate(date).format(format);
